import BigNumber from "bignumber.js";
import { resolveBigNumberishSourcable } from "../state";
export class FeeSourceProvider {
    constructor() {
        this.name = "fee";
    }
    getValue(provider, source, arg, step) {
        return {
            async value() {
                let base = await resolveBigNumberishSourcable(provider, [source.base], step);
                let multiplier = await resolveBigNumberishSourcable(provider, [source.multiplier, 1], step);
                if (base) {
                    let decimals;
                    if (!source.ignoreDecimals) {
                        decimals = await resolveBigNumberishSourcable(provider, [arg?.decimals], step);
                    }
                    if (multiplier === null) {
                        multiplier = "1";
                    }
                    let res = new BigNumber(base).times(multiplier);
                    if (decimals) {
                        res = res.div(`1e${decimals}`);
                    }
                    return res.toString(10);
                }
                return "";
            },
        };
    }
}
